import { forwardRef, useEffect, useRef, useState } from "react";
import { Marker, Popup } from "react-leaflet";

import clientComponent from "../../../config/clientComponents";

const CustomMarker = forwardRef(
  (
    {
      entity,
      MarkerIcon,
      setSelectedInstitution,
      scrollbarInstance,
      lineRefs,
      i,
      colorsArray,
      innerIcon,
      popupRefs,
      filtersKeys,
      sizeState,
    },
    ref
  ) => {
    let MarkerPopup = {};
    if (process.env.REACT_APP_POPUP === "true") {
      MarkerPopup = clientComponent["MarkerPopup"];
    }

    return (
      <Marker
        icon={MarkerIcon}
        key={entity.id}
        position={[entity.latitude, entity.longitude]}
        calc={entity}
        eventHandlers={{
          click: (e) => {
            e.target.refreshIconOptions(null, true);
            setSelectedInstitution(entity);
            if (process.env.REACT_APP_SIDEBAR !== "none") {
              const { viewport } = scrollbarInstance.elements();
              viewport.scrollTo({
                top: lineRefs.current[i].current.offsetTop,
                behavior: "smooth",
              });
            }
          },
        }}
        ref={ref}
      >
        {process.env.REACT_APP_POPUP === "true" && (
          <>
            {sizeState < 992 ? (
              <Popup
                options={entity}
                ref={popupRefs.current[i]}
                autoPanPaddingTopLeft={[50, 50]}
                autoPanPaddingBottomRight={[50, 50]}
                className="my-marker-popup"
              >
                <div className={`d-flex`} key={entity.id} ref={ref}>
                  <div className="img-wrapper">
                    <img
                      src={entity.picture}
                      alt="picture"
                      width="70"
                      height="70"
                    />
                  </div>
                  <div className="d-flex flex-column content">
                    <div className="pb-2 content-wrapper">
                      <div className={`name`}>{entity.name}</div>
                      <div className="address">{entity.address}</div>
                      {entity.phone ? (
                        <div className="phone">
                          <span className="iconReactLeafletGroup"></span>
                          {entity?.phone}
                        </div>
                      ) : (
                        <></>
                      )}

                      <div className="btns-wrapper d-flex">
                        {entity.website ? (
                          <a className="more-infos" href={entity.website}>
                            <span className="icon iconReactLeafletinfo"></span>
                            Plus d'infos
                          </a>
                        ) : (
                          <></>
                        )}
                        <a
                          className="itinerary"
                          target="_blank"
                          href={`https://www.google.com/maps/dir/?api=1&destination=${entity.address.replace(
                            " ",
                            "+"
                          )}`}
                        >
                          <span className="iconReactLeafletmarker"></span>{" "}
                          Itinéraire
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </Popup>
            ) : (
              <></>
            )}
          </>
        )}
      </Marker>
    );
  }
);
export default CustomMarker;
